<template>
  <div class="tabs">
    <div
      v-for="(item, idx) in items"
      :key="idx"
      :class="['tabs__item', {'tabs__item-active': idx === activeIndex}]"
      @click="onTab(idx)"
    >
      {{ item.title }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tabs',
  props: {
    items: Array,
    defaultIndex: Number,
  },
  data() {
    return {
      activeIndex: undefined,
    };
  },
  created() {
    this.activeIndex = this.defaultIndex;
  },
  methods: {
    onTab(idx) {
      if (this.activeIndex !== idx) {
        this.activeIndex = idx;
        this.$emit('change', idx);
      }
    },
  },
};
</script>
<style scoped>
.tabs {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0 20px;
  margin-left: auto;
  margin-right: auto;
  @media (--viewport-desktop-small) {
    width: 970px;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 30px;
    padding: 0;
  }
  @media (--viewport-desktop-medium) {
    width: 90%;
    padding: 0 76px;
  }
}
.tabs::-webkit-scrollbar {
  width: 0;
}
.tabs__item {
  position: relative;
  font-size: 18px;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.4s;
  margin: 0 23px 20px 23px;
  white-space: nowrap;
}
.tabs__item:first-child {
  margin-left: 0;
}
.tabs__item-active {
  color: var(--accent);
}
.tabs__item::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
  border-bottom: solid 2px #fa7778;
  transition: 0.4s;
  opacity: 0;
  transform: translateY(10px);
}
.tabs__item-active::after {
  opacity: 1;
  transform: translateY(0px);
}
</style>
